import reducer from 'circe/listing/reducer';
import actionTypes from './actionTypes';
import { INVOICE_STATUS } from './constants';

const listingReducer = reducer(actionTypes);

const updateObjectInArray = (data, id, values) => data.map((item) => {
  if (item.id === id) {
    return {
      ...item,
      ...values,
    };
  }
  return item;
});

export default (state, action) => {
  switch (action.type) {
    case actionTypes.MARK_AS_PAID:
      return {
        ...state,
        data: updateObjectInArray(state.data, action.payload.id, { isMarkingAsPaid: true }),
      };

    case actionTypes.MARKED_AS_PAID:
      return {
        ...state,
        data: updateObjectInArray(state.data, action.payload.id, {
          isMarkingAsPaid: false,
          status: INVOICE_STATUS.PAID,
        }),
      };
    default:
      return listingReducer(state, action);
  }
};
